import {boxShadowTokens as boxShadows} from './box-shadows';
import {breakpoints} from './breakpoints';
import {controlTokens as controls} from './controls';
import {colors} from './colors';
import {opacityTokens as opacities} from './opacities';
import {radii} from './radii';
import {space} from './space';

import {typographyTokens as typography, uiTokens as ui} from './sizing';

/**
 * This should be the prefer way to consume tokens.
 * Individual usage of tokens should be deprecated.
 *
 * 2023-01-16
 */
export const tokens = {
  boxShadows,
  breakpoints,
  colors,
  controls,
  opacities,
  radii,
  space,
  typography,
  ui,
} as const;

export type ThemeTokens = typeof tokens;
